import { api } from './api-client';

const PANEL_API = '/panel/api';

export interface WgUser {
  name: string;
  wgIp: string;
  createdSec: number;
  /** Son el sıkışmadan bu yana sn; hiç el sıkışmadıysa null */
  handshakeAgeSec: number | null;
  /** Conf sunucuda saklı mı (eski kayıtlarda olmayabilir) */
  hasConf: boolean;
}

/** Conf yanıtı (private key dahil) — sunucuda /opt/smg/users altında saklanır,
 * listeden her zaman yeniden indirilebilir. */
export interface WgCreated {
  name: string;
  wgIp: string;
  conf: string;
}

export const wg = {
  async list(): Promise<WgUser[]> {
    const r = await api.get<{ users: WgUser[] }>(`${PANEL_API}/wg/users`);
    return r.users;
  },
  async create(name: string): Promise<WgCreated> {
    return api.post<WgCreated>(`${PANEL_API}/wg/users`, { name });
  },
  async getConf(name: string): Promise<WgCreated> {
    return api.get<WgCreated>(`${PANEL_API}/wg/users/${encodeURIComponent(name)}/conf`);
  },
  async remove(name: string): Promise<void> {
    await api.delete(`${PANEL_API}/wg/users/${encodeURIComponent(name)}`);
  },
};
